<div class="dialog-header">
	<div class="header-title"><span style="font-size: 145%;">Profile</span></div>

	<button mat-button class="close-button-container" mat-dialog-close disableRipple="true">
		<mat-icon>clear</mat-icon>
	</button>
</div>

<div class="edit-block">
	<div class="avatar-block">
		<div class="word-avatar" style.background-color="#{{currentUser.bgColor}}">
			<div class="short-name">
				{{currentUser.shortCode}}
			</div>

			<!-- TODO WITH PHOTO UPLOAD -->
			<!-- <button mat-button class="change-photo-button" (click)="changePhoto()">
				<mat-icon>photo_camera</mat-icon>
			</button> -->
		</div>
	</div>

	<form #accountEditForm="ngForm">
		<div class="form-block">

			<div class="form-row">
				<div class="icon-block">
					<mat-icon>account_circle</mat-icon>
				</div>
				<mat-form-field> <input matInput placeholder="User Name" [required]="true" [(ngModel)]="temporaryName"
						name="temporaryName"> </mat-form-field>
			</div>
			<div class="form-row">
				<div class="icon-block">
					<mat-icon>call</mat-icon>
				</div>
				<mat-form-field> <input matInput placeholder="Phone" type="phone" [(ngModel)]="temporaryPhone"
						name="temporaryPhone"> </mat-form-field>
			</div>
			<div class="form-row">
				<div class="icon-block">
					<mat-icon>email</mat-icon>
				</div>
				<mat-form-field> <input matInput placeholder="E-Mail" type="email" [(ngModel)]="temporaryEmail"
						name="temporaryEmail"> </mat-form-field>
			</div>
			<div class="form-row">
				<div class="icon-block">
					<mat-icon>lock</mat-icon>
				</div>
				<mat-form-field class="password-field"> <input matInput placeholder="Password" type="password" readonly
						value="12345678910">
					<button mat-button (click)="openChangePasswordDialog()" [tabindex]="-1" type="button">Change</button>
				</mat-form-field>
			</div>

		</div>
		<div class="save-btn-block">
			<button mat-button class="save-btn" (click)="saveUserData()" [disabled]="!accountEditForm.form.valid"
				tabindex="1" type="submit">Save</button>
		</div>
	</form>
</div>